import { Route, Routes } from 'react-router-dom';

import { NotFound } from 'common/components';

import Filter from './components/Filter';
//import Table from './components/Table';
//import { message } from 'antd';
import { FilterPayload } from 'api/dashboard';
import { t } from 'i18next';
import { useCallback } from 'react';

const DashboardContainer = () => {
  // const { userId = '' } = useAuth();

  // const userPro = useFetchUser(userId);

  // let user: User = {
  //   id: '',
  //   isConfirmed: false,
  //   email: ''
  // };
  // userPro.then(result => {
  //
  //   user = result.user;
  // })

  const handleSubmit = useCallback(
    async (_payload: FilterPayload) => {
      // await changePassword(payload);
      // console.log(payload);
      //message.success('Success');
    },
    [t]
  );

  // if (!user) {
  //   return <LoadingScreen />;
  // }

  return (
    <Routes>
      <Route
        element={
          <>
            <Filter isLoading={false} onSubmit={handleSubmit} />
            {/* <Table /> */}
          </>
        }
      >
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default DashboardContainer;
